import * as React from 'react';
import {
    Create,
    TextInput,
    NullableBooleanInput,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    required,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

const PodcastTopicCreate = () => {
    return (
        <Create redirect={'/podcast-topics'}>
            <SimpleForm>
                <FileUpload type="VIDEO_THUMBNAIL" source={'Thumbnail'} accept={'image/*'} />
                <TextInput
                    source="Name"
                    fullWidth
                    name={'name'}
                    validate={[required(), validateNotEmpty]}
                />
                <TextInput
                    source="DisplayOrder"
                    type="number"
                    fullWidth
                    parse={value => (value === '' ? null : parseInt(value, 10))}
                />
            </SimpleForm>
        </Create>
    );
};

export default PodcastTopicCreate;
